import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { issuesAPI } from '../../services/api';
import Seo from '../../components/Seo';

const vendorEvents = [
  { value: 'kyc process', label: 'KYC Process' },
  { value: 'wallet balance', label: 'Wallet Balance' },
  { value: 'sending offer to demands', label: 'Sending Offer to Demands' },
  { value: 'bulk sale', label: 'Bulk Sale' },
  { value: 'chat functionality', label: 'Chat Functionality' },
  { value: 'app issue', label: 'App Issue' }
];

export default function ReportIssue() {
  const navigate = useNavigate();
  const [event, setEvent] = useState('');
  const [description, setDescription] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!event) {
      return setError('Please select an event category.');
    }
    if (!description.trim()) {
      return setError('Please provide a description of the issue.');
    }

    const confirmed = window.confirm('Are you sure you want to submit this issue report?');
    if (!confirmed) return;

    setBusy(true);
    try {
      const res = await issuesAPI.create({
        event,
        description: description.trim()
      });

      if (res.data?.success) {
        setSuccess('Your report has been submitted successfully.');
        setEvent('');
        setDescription('');
        setTimeout(() => {
          navigate('/vendor/dashboard');
        }, 2000);
      } else {
        setError(res.data?.message || 'Failed to submit report.');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to submit report.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '16px' }}>
      <Seo title="Report an Issue - Kanjusee" />
      <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: 26, fontWeight: 700, color: 'var(--char)', marginBottom: 24 }}>
        Report an Issue
      </h1>

      <div className="card">
        <p style={{ fontSize: 14, color: '#6B7280', marginBottom: 20 }}>
          Describe the problem you are experiencing. Select an event category and provide details so our team can assist you.
        </p>

        {success && <div style={{ background: '#ecfdf5', color: '#065f46', padding: '12px 16px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>{success}</div>}
        {error && <div style={{ background: '#fef2f2', color: '#991b1b', padding: '12px 16px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>{error}</div>}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label className="form-label" style={{ fontWeight: '600', marginBottom: 6 }}>Select Issue Category</label>
            <select
              className="form-input"
              value={event}
              onChange={(e) => setEvent(e.target.value)}
              required
              style={{ width: '100%', height: '42px', padding: '0 8px', borderRadius: '6px', border: '1px solid var(--border)' }}
            >
              <option value="">-- Choose the event category --</option>
              {vendorEvents.map(ev => (
                <option key={ev.value} value={ev.value}>{ev.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="form-label" style={{ fontWeight: '600', marginBottom: 6 }}>Description</label>
            <textarea
              className="form-input"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Describe the issue in detail..."
              required
              rows={5}
              style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid var(--border)', resize: 'vertical' }}
            />
          </div>

          <div style={{
            backgroundColor: '#FFFBEB',
            borderColor: '#FDE68A',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderRadius: '8px',
            padding: '16px',
            fontSize: '13px',
            color: '#B45309',
            fontWeight: '600',
            lineHeight: '1.4'
          }}>
            ⚠️ Warning: Make sure the issue is legit. If we find its fake, we have authority to take action against you.
          </div>

          <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
            <button
              type="submit"
              disabled={busy}
              style={{
                background: 'var(--green)',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '12px 24px',
                fontSize: 14,
                fontWeight: 700,
                cursor: busy ? 'not-allowed' : 'pointer',
                opacity: busy ? 0.7 : 1
              }}
            >
              {busy ? 'Submitting...' : 'Submit Report'}
            </button>
            <button
              type="button"
              onClick={() => navigate('/vendor/dashboard')}
              style={{
                background: '#fff',
                color: '#374151',
                border: '1px solid #D1D5DB',
                borderRadius: 8,
                padding: '12px 24px',
                fontSize: 14,
                fontWeight: 700,
                cursor: 'pointer'
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
